module.exports = __webpack_public_path__ + "img/safety_alarm.4b3a1fe4.svg";